import Service from './service'
export var BarcodeMessageType;
(function (BarcodeMessageType) {
  BarcodeMessageType["BARCODE_STATUS"] = "BARCODE_STATUS"
  BarcodeMessageType["BARCODE_CONNECTED"] = "BARCODE_CONNECTED"
  BarcodeMessageType["BARCODE_ERROR"] = "BARCODE_ERROR"
  BarcodeMessageType["BARCODE_RESULT"] = "BARCODE_RESULT"
})(BarcodeMessageType || (BarcodeMessageType = {}))
export var ApiBarcodeMessageType;
(function (ApiBarcodeMessageType) {
  ApiBarcodeMessageType["READER_BARCODE_REQUEST"] = "reader.barcode.request"
  ApiBarcodeMessageType["READER_BARCODE_RESPONSE"] = "reader.barcode.response"
})(ApiBarcodeMessageType || (ApiBarcodeMessageType = {}))
/**
 * Сервис для работы со считывателем штрих-кодов
 * @version 0.0.1
 * @since 2.0.0
 */
export default class BarcodeService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiBarcodeMessageType.READER_BARCODE_RESPONSE:
          delete message.id
          delete message.type
          this.broadcast(BarcodeMessageType.BARCODE_STATUS, message)
          if (typeof message.result !== 'undefined') {
            this.broadcast(BarcodeMessageType.BARCODE_RESULT, message.result)
          }
          else if (typeof message.error !== 'undefined') {
            this.broadcast(BarcodeMessageType.BARCODE_ERROR, message.error)
          }
          else if (typeof message.connected !== 'undefined') {
            this.broadcast(BarcodeMessageType.BARCODE_CONNECTED, message.connected)
          }
          break
      }
    }
    this.waiters = {
      environment: [],
    }
    this.messageChannel.subscribe(ApiBarcodeMessageType.READER_BARCODE_RESPONSE, messageHandler)
  }
  /**
     * Запросить статус подключения считывателя штрих-кодов
     * @since 2.0.0
     *
     * @return {*}  {void}
     * @memberof BarcodeService
     *
     * @example <caption>запросить статус подключения считывателя штрих-кодов</caption>
     * robot.barcodeService.getStatus()
     */
  getStatus() {
    return this.messageChannel.send({
      type: ApiBarcodeMessageType.READER_BARCODE_REQUEST,
      connected: '',
    })
  }
  /**
     * Сервис штрих-кодов ответил
     * @since 2.0.0
     *
     * @param {(message: Message) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof BarcodeService
     *
     * @example <caption>cервис штрих-кодов ответил</caption>
     * robot.barcodeService.onStatus((message) => {
     *   ...
     * })
     */
  onStatus(callback) {
    return this.subscribe(BarcodeMessageType.BARCODE_STATUS, callback)
  }
  /**
     * Сервис штрих-кодов прислал сведения о подключении
     * @since 2.0.0
     *
     * @param {(isConnected: boolean) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof BarcodeService
     *
     * @example <caption>cервис штрих-кодов прислал сведения о подключении</caption>
     * robot.barcodeService.onConnected((isConnected) => {
     *   ...
     * })
     */
  onConnected(callback) {
    return this.subscribe(BarcodeMessageType.BARCODE_CONNECTED, callback)
  }
  /**
     * Сервис штрих-кодов прислал ошибку
     * @since 2.0.0
     *
     * @param {(error: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof BarcodeService
     *
     * @example <caption>cервис штрих-кодов прислал ошибку</caption>
     * robot.barcodeService.onError((error) => {
     *   ...
     * })
     */
  onError(callback) {
    return this.subscribe(BarcodeMessageType.BARCODE_ERROR, callback)
  }
  /**
     * Сервис штрих-кодов прислал результат считывания
     * @since 2.0.0
     *
     * @param {(result: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof BarcodeService
     *
     * @example <caption>cервис штрих-кодов прислал результат считывания</caption>
     * robot.barcodeService.onResult((result) => {
     *   ...
     * })
     */
  onResult(callback) {
    return this.subscribe(BarcodeMessageType.BARCODE_RESULT, callback)
  }
}
